import { format } from "date-fns";

const formatDate = (date: Date | number, dateFormat: string = "dd/MM/yy") => {
  const dateObject = typeof date === "number" ? new Date(date * 1000) : date;
  const formattedDate = format(dateObject, dateFormat);
  return formattedDate;
};

export default formatDate;
